import React from "react";
import { connect } from "react-redux";
import { MetypeCommentingWidget } from "@metype/components";
import PropTypes from "prop-types";

function generateHostUrl(story = {}) {
  if (global.location) {
    return `${global.location.origin}/${story.slug}`;
  }
}

function CommentingWidgetBase(props) {
  const metypeConfig = props.config && props.config["metype-config"] ? props.config["metype-config"] : {};
  return (
    <MetypeCommentingWidget
      host={metypeConfig.host}
      accountId={metypeConfig.accountId}
      pageURL={generateHostUrl(props.story)}
      primaryColor={metypeConfig.primaryColor}
    />
  );
}

CommentingWidgetBase.propTypes = {
  config: PropTypes.shape({
    "metype-config": PropTypes.object
  }),
  story: PropTypes.object
};
const mapStateToProps = state => {
  return {
    config: state.qt.config || {}
  };
};
export const CommentingWidget = connect(mapStateToProps, {})(CommentingWidgetBase);
